var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0719 11.376L12.3679 12.08L8.27191 8L12.3679 3.92L13.0719 4.624L10.1919 7.504L17.0559 7.504V8.496H10.1919L13.0719 11.376ZM7.61591 14H2.94391L2.94391 2H7.61591L7.61591 14ZM15.9359 15.008V12.496H16.9439V15.008C16.9439 15.2853 16.8479 15.52 16.6559 15.712C16.4532 15.904 16.2132 16 15.9359 16L1.93591 16C1.65857 16 1.42391 15.904 1.23191 15.712C1.03991 15.52 0.943909 15.2853 0.943909 15.008L0.943909 0.991999C0.943909 0.725332 1.03991 0.495999 1.23191 0.303999C1.42391 0.101333 1.65857 0 1.93591 0L15.9359 0C16.2132 0 16.4532 0.0959988 16.6559 0.287999C16.8479 0.479999 16.9439 0.714665 16.9439 0.991999L16.9439 3.504H15.9359V0.991999L1.93591 0.991999L1.93591 15.008L15.9359 15.008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/Open.f895fc062308380071f7d75c4ec36c00.svg";
export { ForwardRef as ReactComponent };